export const INTENSIVIST_COMMAND_CENTER_STATUS_OPTIONS = [
  {
    label: 'Pending',
    value: 'arrived',
  },
  {
    label: 'Accepted',
    value: 'finished',
  },
  {
    label: 'Rejected',
    value: 'cancelled',
  },
]

export const VISIT_STATUS_OPTIONS = [
  {
    label: 'InProgress',
    value: 'triaged',
  },
  {
    label: 'Completed',
    value: 'finished',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
]

export const INTENSIVIST_COMMAND_CENTER = 'Intensivist Command Centre'
export const DELETE_DOCUMENT_ERROR_MESSAGE = 'Error while deleting document'
export const DELETE_DOCUMENT_SUCCESS_MESSAGE = 'Document deleted successfully'
export const paramsId = 'id'
export const paramsBedId = 'bedId'
export const paramsBedStatus = 'bedStatus'
export const ipdRegId = 'regId'
